import React, { Fragment, useState, useEffect } from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Alert from '@mui/material/Alert';

import { setDataAction  } from 'redux/actions/getFormActions';

const useStyles = makeStyles((theme) => ({
    select: {
        '& .MuiSvgIcon-root': {
            color: theme.palette.primary.main
        },
        '&:hover': {
            backgroundColor: '#e4dfdf6b'
        }
    },
    icon: {
        fill: theme.palette.primary,
    },
}));

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;
  
    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        isNumericString
        prefix="$"
        decimalScale={3}
      />
    );
  });
  
  NumberFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

const Form2 = (props) => {
    const {actions, token, formData, handleNext, handleBack } = props;
    const classes = useStyles();

    const [depositAmount, setDepositAmount] = useState(null);
    const [agreeRadio, setRadio] = useState(null);
    const [agreeDate, setAgreeDate] = useState(null);
    const [relatedExpense, setRelatedExpense] = useState(null);
    const [claimType, setClaimType] = useState(null)


    useEffect(() => {
        setAgreeDate(formData.data.agreePayDate || null);
        setDepositAmount(formData.data.depositAmount);
        setRadio(formData.data.paymentAgreement || null);
        setRelatedExpense(formData.data.relatedExpense);
        setClaimType(formData.data.claimType);                                                     
    }, [formData])

    const handleDepositAmount = (event) => {
        setDepositAmount(event.target.value);
      };

    const handleRadio = (event) => {
      if(event.target.value === 'No') {
        setAgreeDate(null);
      }
      setRadio(event.target.value)
    }

    const handleClaimType = (value) => {
      setClaimType(value);
      if(value === 'No Show') setRelatedExpense('No')
    }

    const handleDate = (e) => {
      if(e && e['$d'] != 'Invalid Date') {
        const value = new Date(e['$d']).toISOString().slice(0, 10);
        setAgreeDate(value);
      }
    }

    const handleNextButton = () => {
        actions.setDataAction({
            ...formData.data,
            paymentAgreement: agreeRadio,
            agreePayDate: agreeDate,
            depositAmount: depositAmount,
            claimType: claimType,
            relatedExpense: relatedExpense,
        })
        handleNext();
    }
    let disable = true;
    if(depositAmount && claimType) {
      if (relatedExpense && agreeRadio) {
        if(agreeRadio === 'Yes') disable = agreeDate ? false : true;
        else disable = false
      } 
      else disable = true;
    }

  return (
    <Fragment>
      {/* <Typography variant="h6" gutterBottom color="primary" sx={{mt: 5}}>
        Locate Your Apartment Complex
      </Typography> */}
        <Typography color="primary" variant="h5" align='center' sx={{ mt: 5}}>     
            Type of Claim
        </Typography>
        <Grid container justifyContent='center' sx={{my: 1}}>
          <FormControl>
              <RadioGroup
                row
                value={claimType}
                onChange={e => handleClaimType(e.target.value)}
              >
                  <FormControlLabel 
                    value="No Show" 
                    control={<Radio />} 
                    label={
                      <Grid container>
                        <Typography color="primary">No Show</Typography>
                        <Tooltip title={<Typography variant='body1'>Tenant never took possession of the unit</Typography>} placement="right-start" arrow>
                          <HelpIcon fontSize='small'  color="primary" />
                        </Tooltip>
                      </Grid>
                  } />
                  <FormControlLabel 
                    value="Tenant Default" 
                    control={<Radio />} 
                    label={
                      <Grid container>
                        <Typography color="primary">Tenant Default</Typography>
                        <Tooltip title={<Typography variant='body1'>Tenant took possession of unit and defaulted or skipped on rent after move-in</Typography>} placement="right-start" arrow>
                          <HelpIcon fontSize='small'  color="primary" />
                        </Tooltip>
                      </Grid>
                    } 
                  />
              </RadioGroup>
          </FormControl>
        </Grid>
        <Typography color="primary" variant="h6" align='center' sx={{ mt: 2}}>     
          Are there other related expenses for this claim?
          <Tooltip title={
            <Typography variant='body1'>
              Related Expenses equals legal and filing expenses for eviction proceedings paid to third parties as a result of Tenant Default.
            </Typography>
            } 
            placement="right-start" 
            arrow
            sx={{ml:1}}
          >
              <HelpIcon fontSize='small'  color="primary" />
          </Tooltip>
        </Typography>
        <Grid container justifyContent='center'>
            <FormControl disabled={claimType === 'No Show'}>
                <RadioGroup
                  row
                  value={relatedExpense}
                  onChange={e => setRelatedExpense(e.target.value)}
                >
                    <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value="No" control={<Radio />} label="No" />
                </RadioGroup>
            </FormControl>
        </Grid>
        {claimType === 'No Show' &&
            <Alert  severity="info">
                    "Please upload any document or documentation that confirms the tenant's intent to move in the unit within 90 days of the lease start date under Other Documents on page(5)"
            </Alert>
        }
        {claimType !== 'No Show' && relatedExpense === 'Yes' &&  
              <Alert  severity="info">
                  "Please be sure to upload related expense documents and invoices under Other Documents on page(5)"
              </Alert>
        }
        <Typography color="primary" variant="h6" align='center' sx={{ mt: 3}}>     
              Have you worked out a payment agreement timeline?
        </Typography>
        <Grid container justifyContent='center'>
            <FormControl>
                <RadioGroup
                  row
                  value={agreeRadio}
                  onChange={handleRadio}
                >
                    <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value="No" control={<Radio />} label="No" />
                </RadioGroup>
            </FormControl>
        </Grid>
        {agreeRadio === 'Yes' &&
            <Grid container justifyContent='center' sx={{ my: 2}}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    variant="standard"
                    label="Agreed Payment Date"
                    inputFormat="DD/MM/YYYY"
                    minDate="01/01/2018"
                    value={agreeDate}
                    onChange={(e) => handleDate(e)}
                    renderInput={(params) => <TextField variant="standard" {...params} sx={{svg: {color: '#702572'}}} />}
                  />
              </LocalizationProvider>
            </Grid>
        } 
          <Grid container justifyContent='center' alignItems="center" sx={{mt:3}}>
            <Grid item xs={12} md={8}>
              <Typography variant='h7' color="primary" textAlign="center">Please enter the amount of security deposit you have on hand:</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                  variant="standard"
                  color={depositAmount ? "primary" : "error"}
                  required
                  value={depositAmount}
                  onChange={handleDepositAmount} 
                  InputProps={{
                      inputComponent: NumberFormatCustom,
                  }}
                  sx={{ml:2}}
                  />
            </Grid>
          </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', py: 2, mt: 3 }}>
                <Button
                onClick={handleBack}
                sx={{ mr: 1 }}
                variant="contained"
                >
                Back
                </Button>

            <Button onClick={handleNextButton} variant="contained" disabled={disable}>
                <Typography variant='body1' >
                    Next
                </Typography>
            </Button>
        </Box>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
    return {
        formData: state.formData
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      actions: bindActionCreators({ 
            setDataAction, 
        }, dispatch),
    };
  };
  
export default connect(mapStateToProps, mapDispatchToProps)(Form2);
